import { useCallback, useEffect, useState, useRef } from "react"

// swiping on mobile devices, code from: https://www.freecodecamp.org/news/how-to-build-mobile-swiping-component-in-react/

export default function MobileSwiper({ children, onSwipe }) {
    const wrapperRef = useRef(null)
    const startX = useRef(0)
    const startY = useRef(0)

    const handleTouchStart = useCallback((e) => {
        startX.current = e.touches[0].clientX
        startY.current = e.touches[0].clientY
    }, [])

    const handleTouchEnd = useCallback(
        (e) => {
            const endX = e.changedTouches[0].clientX
            const endY = e.changedTouches[0].clientY
            const deltaX = endX - startX.current
            const deltaY = endY - startY.current
            if (Math.abs(deltaX) > 30 || Math.abs(deltaY) > 30) {
                e.preventDefault()
                onSwipe({ deltaX, deltaY })
            }
    }, [onSwipe])
    
    return (
            <div
                ref={wrapperRef}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                {children}
            </div>
        )
}